import { Box, Typography } from '@mui/material';
import { brandColors } from 'types/colors';

const STATUS_LABEL_COLORS = {
  ONLINE: brandColors.GREEN,
  ACTIVE: brandColors.GREEN,
  OFFLINE: brandColors.GREY,
  INACTIVE: brandColors.GREY,
};

const SmallStatusLabel = props => {
  const statusColor = STATUS_LABEL_COLORS[props.statusLabel?.toUpperCase()] || brandColors.GREY_DARK;

  return (
    <Box
      sx={{
        borderRadius: '1rem',
        px: '.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '.3rem',
        scale: props.scale || 1,
      }}>
      <Box
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          backgroundColor: statusColor,
          boxShadow: `0px 0px 0px 2px ${statusColor}50`,
        }}
      />
      <Typography sx={{ color: statusColor, fontSize: '.9rem', fontWeight: '600', lineHeight: '1.4' }}>
        {props.statusLabel}
      </Typography>
    </Box>
  );
};

export default SmallStatusLabel;
